import React from 'react';
import Layout from '../../common/Layout';
import SEO from '../../common/SEO';
import SectionHome from '../../components/sectionHome/SectionHome';
import SectionWrapper from '../../components/shared/SectionWrapper';
import ContentSection from '../../components/shared/ContentSection';

const SobreNosotros = () => {
    // Data for Sede section
    const sedeContent = [
        "En 2025 el Centro Italiano di Lingua e Cultura, formado por la cooperativa de profesores ADOC, abrió su propia sede en el Edificio Libertad, en Plaza Cagancha.",
        "Aquí brinda los cursos presenciales de lengua y cultura italianas, así como los cursos de cocina. Próximamente, comenzará a organizar actividades culturales y recreativas para todo aquel que esté interesado y desee participar."
    ];

    const sedeImages = [
        { src: "/images/about/about-09/sede/sede-1.png", alt: "Sede en Plaza Cagancha" },
        { src: "/images/about/about-09/sede/sede-2.png", alt: "Interior de la Sede" },
        { src: "/images/about/about-09/sede/sede-3.png", alt: "Salón de Clases" },
        { src: "/images/about/about-09/sede/sede-4.png", alt: "Salón de Clases" },
        { src: "/images/about/about-09/sede/sede-5.png", alt: "Salón de Clases" },
        { src: "/images/about/about-09/sede/sede-6.png", alt: "Salón de Clases" },
        { src: "/images/about/about-09/sede/sede-7.png", alt: "Salón de Clases" }
    ];

    // Data for Profes section
    const profesContent = [
        "El Centro Italiano di Lingua e Cultura está creado por la cooperativa ADOC, que imparte cursos de lengua y cultura italiana ininterrumpidamente desde marzo de 2001, habiendo trabajado hasta el año 2024 para el Instituto Italiano di Cultura di Montevideo.",
        "Forman parte de nuestro equipo docente egresados del Instituto de Profesores Artigas, de Traductorado Público de la UDELAR o de universidades italianas. Además, los docentes poseen la certificación de examinadores para exámenes internacionales de la Universidad de Perugia y de suministradores para los internacionales de la Universidad de Siena.",
        "Ofrecen también formación linguistica a miembros de empresas locales e internacionales.",
        "Navegá para conocer nuestro staff docente!"
    ];

    const profesImages = [
        { src: "/images/about/about-09/profes/profe-1.png", alt: "Profesor 1" },
        { src: "/images/about/about-09/profes/profe-2.png", alt: "Profesor 2" },
        { src: "/images/about/about-09/profes/profe-3.png", alt: "Profesor 3" },
        { src: "/images/about/about-09/profes/profe-4.png", alt: "Profesor 4" },
        { src: "/images/about/about-09/profes/profe-5.png", alt: "Profesor 5" },
        { src: "/images/about/about-09/profes/profe-6.png", alt: "Profesor 6" },
        { src: "/images/about/about-09/profes/profe-7.png", alt: "Profesor 7" },
        { src: "/images/about/about-09/profes/profe-8.png", alt: "Profesor 8" }
    ];

    // Data for Edilingua section
    const edilinguaContent = [
        "Desde el año 2023 y gracias a estrategias comerciales, somos al día de hoy los únicos representates oficiales de la Editorial Edilingua en Uruguay.",
        "Nos dedicamos no solo a la importación de libros para los cursos sino que, además, importamos libros de gramática y vocabulario, así como libros recreativos y juegos para potenciar las habilidades adquiridas en el idioma."
    ];

    const edilinguaImage = (
        <div className="about-image-gallery">
            <img src="/images/about/about-09/EDILINGUA.png" alt="Logo Edilingua" />
        </div>
    );

    return (
        <>
            <SEO title="Sobre Nosotros" />
            <Layout>
                <div className="edu-about-area about-style-1 bg-color-white">
                    {/* Header Section - More compact */}
                    <div className="container" id="home-about">
                        {/* Nombre Cabezal Section */}
                        <div className="row g-5 mb-5">
                            <div className="col-12 text-center">
                                <img
                                    src="/images/about/about-09/nombre_cabezal.png"
                                    alt="Nombre Cabezal"
                                    className="img-fluid"
                                    style={{ maxWidth: "600px", margin: "32px auto 32px auto", display: "block" }}
                                />
                            </div>
                        </div>
                        <div className="row g-5 align-items-center justify-content-center" id="images-text-container-home">
                            <div className="col-lg-3 col-xl-3 col-images text-center" id="home-image-left">
                                <img 
                                    id="image-home-left" 
                                    src="/images/about/about-09/uru_it_home.png" 
                                    alt="About Images"
                                    className="header-icon"
                                />
                            </div>
                            <div className="col-lg-6 col-xl-6" id="text-container">
                                <div className="inner text-center">
                                    <div className="section-title">
                                        <div className="inner-section-title">
                                            <h3 className="title mb-3">Clases de italiano</h3>
                                        </div>
                                        <hr className="mb-3" />
                                    </div>
                                    <div className="about-feature-list">
                                        <div className="our-feature">
                                            <div className="icon mb-2">
                                                <i className="icon-Hand---Book"></i>
                                            </div>
                                            <div className="feature-content">
                                                <h6 className="feature-title">Cursos presenciales y online</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-xl-3 col-images text-center" id="logo-div-img">
                                <img 
                                    src="/images/logo/logo.png" 
                                    alt="About Images"
                                    className="header-icon"
                                />
                            </div>
                        </div>
                    </div>

                    <div className="edu-service-area service-wrapper-3">
                        {/* Sede Section */}
                        <SectionWrapper title="Nuestra Sede">
                            <ContentSection 
                                textContent={sedeContent}
                                images={sedeImages}
                            />
                        </SectionWrapper>

                        {/* Profes Section - Updated title */}
                        <SectionWrapper title="Nuestro Equipo Docente" additionalClass="pb--70">
                            <ContentSection 
                                textContent={profesContent}
                                images={profesImages}
                            />
                        </SectionWrapper>

                        {/* Edilingua Section - Updated title */}
                        <SectionWrapper title="Representantes de Edilingua">
                            <ContentSection 
                                textContent={edilinguaContent}
                                imageComponent={edilinguaImage}
                            />
                        </SectionWrapper>
                    </div>
                </div>
            </Layout>
        </>
    );
};

export default SobreNosotros; 